// @flow
import * as React from "react";

const TournamentId = React.createContext(null);

export default TournamentId;

type Props = {
  children: React.Node
};

export type TournamentIdContext = {
  tournamentId: null | number,
  changeTournamentId: (tournamentId: number) => void
};

export class TournamentIdProvider extends React.Component<
  Props,
  TournamentIdContext
> {
  changeTournamentId = (tournamentId: null | number) => {
    this.setState(state => ({
      tournamentId
    }));
  };

  state = {
    tournamentId: null,
    changeTournamentId: this.changeTournamentId
  };

  render() {
    return (
      <TournamentId.Provider value={this.state}>
        {this.props.children}
      </TournamentId.Provider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Tournaments/TournamentId.js